import RateCalculator from "../../components/RateCalculator";
import ShopStrip from "../../components/home/ShopStrip";

export default function RatesPage() {
  return (
    <div data-testid="rates-page" className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-navy sm:text-3xl">Rate Calculator</h1>
        <p className="mt-1 text-sm text-slate-500">Compare live courier rates across the INDIAFAST network</p>
      </div>
      <RateCalculator />
      <div className="-mx-6"><ShopStrip /></div>
    </div>
  );
}
